import 'driver.js/dist/driver.css';
import './assets/home-v2-agent-guide.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { HomeV2EntryOnboardingService } from './home-v2-entry-onboarding-service';
import { HomeV2EntryOnboardingServiceImpl } from './impls/home-v2-entry-onboarding-service';
import { HomeV2WelcomePresenter } from './home-v2-welcome-presenter';
import { HomeV2WelcomePresenterImpl } from './impls/home-v2-welcome-presenter';

/** 注册 Home V2 Welcome、Agent Step 1 与输入引导编排服务。 */
export const homeV2EntryOnboardingModule = (bind: interfaces.Bind) => {
    bind(HomeV2WelcomePresenter)
        .to(HomeV2WelcomePresenterImpl);
    bind(HomeV2EntryOnboardingService)
        .to(HomeV2EntryOnboardingServiceImpl)
        .inSingletonScope();
};

export { HomeV2EntryOnboardingService } from './home-v2-entry-onboarding-service';
export { HomeV2EntryOnboardingServiceImpl } from './impls/home-v2-entry-onboarding-service';
export { HomeV2WelcomePresenter } from './home-v2-welcome-presenter';
export { HomeV2WelcomePresenterImpl } from './impls/home-v2-welcome-presenter';
export type {
    HomeV2EntryOnboardingStartOptions,
    HomeV2OnboardingAgent,
} from './home-v2-entry-onboarding-service';
